import { AboutUsHeroSection, TeamSection, ScrollReveal } from "../components";
import { Outlet, useLocation } from "react-router-dom";

export default function AboutUsPage() {
  const location = useLocation();
  const isPersonDetail = location.pathname.includes('/person/');

  if (isPersonDetail) {
    return <Outlet />;
  }

  return (
    <main className="mb-16">
      <ScrollReveal><AboutUsHeroSection /></ScrollReveal>
      {/* <ScrollReveal><BoardOfAdvisorSection /></ScrollReveal> */}
      {/* <ScrollReveal><FoundersSection /></ScrollReveal> */}
      <ScrollReveal><TeamSection /></ScrollReveal>
    </main>
  );
}